import { useState } from "react";
import campaignSortIcon from '../assets/images/svg/campaign-sort-icon.svg';

export const SORT_OPTIONS = [
  "Start Date: New to Old",
  "Start Date: Old to New",
  "Most Engaged [All Time]",
  "Lowest cost/Results [All Time]",
];

interface SortSelectorProps {
  selectedSort?: string;
  onSortChange?: (sortOption: string) => void;
}

export default function SortSelector({ selectedSort, onSortChange }: SortSelectorProps) {
  const [internalSelected, setInternalSelected] = useState(SORT_OPTIONS[0]);
  const [open, setOpen] = useState(false);

  // Use external prop if provided, otherwise use internal state
  const selected = selectedSort ?? internalSelected;

  const handleSortChange = (option: string) => {
    if (onSortChange) {
      onSortChange(option);
    } else {
      setInternalSelected(option);
    }
    setOpen(false);
  };

  return (
    <div className="relative">
      {/* Trigger - Same styling as existing button */}
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 px-4 py-3 rounded-lg text-[#4B4F55] font-[500] leading-[130%] tracking-[0] font-[style:'Medium'] text-[18px] transition-opacity"
      >
        <span>Sort</span>
        <img src={campaignSortIcon} alt="Sort" className="w-[22px] h-[16px]" />
      </button>

      {/* Dropdown */}
      {open && (
        <div
          className="absolute mt-2 right-0 overflow-hidden z-50 flex flex-col"
          style={{
            width: '320px',
            borderRadius: '16px',
            borderWidth: '1px',
            borderColor: '#82879833',
            borderStyle: 'solid',
            paddingTop: '24px',
            paddingRight: '36px',
            paddingBottom: '24px',
            paddingLeft: '36px',
            gap: '3px',
            backgroundColor: '#1A1B1F'
          }}
        >
          {SORT_OPTIONS.map((option, index) => {
            const isSelected = option === selected;

            return (
              <button
                key={index}
                disabled={isSelected}
                onClick={() => handleSortChange(option)}
                className={`w-full text-left py-3
                  ${isSelected
                    ? "text-[#58F2A9] cursor-not-allowed  text-[14px] font-[400]"
                    : "text-white text-[14px] font-[400]"
                  }`}
                style={index !== SORT_OPTIONS.length - 1 ? { borderBottom: '1px solid rgba(255,255,255,0.1)' } : {}}
              >
                {option}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
